module.exports = __webpack_public_path__ + "img/sec-ahead.bff8d184.svg";